import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { CONTACT } from "@/data/content";

const Footer = () => (
  <footer data-testid="site-footer" className="relative border-t border-white/10 bg-[#0a2a6b]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <div className="grid gap-12 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-3">
            <img
              src="/assets/logo-eg.png"
              alt="EG 6.1 — Électricité Générale"
              className="h-11 w-11 rounded-xl object-cover border border-white/20"
            />
            <span className="font-display text-2xl font-extrabold text-white">
              EG <span className="text-brand-yellow">6.1</span>
            </span>
          </div>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-slate-400">
            SARL EG 6.1 — Électricité générale, domotique, pompes à chaleur, motorisation de portail, volets roulants & VMC.
          </p>
          <p className="mt-4 text-xs font-mono uppercase tracking-[0.2em] text-slate-500">
            {CONTACT.founders.join("  •  ")}
          </p>
          <p className="mt-2 text-xs font-mono uppercase tracking-[0.2em] text-brand-yellow/70">
            Certifié {CONTACT.certifications.join(" • ")}
          </p>
        </div>

        <div>
          <h3 className="text-xs font-mono uppercase tracking-[0.28em] text-brand-yellow">Navigation</h3>
          <ul className="mt-5 space-y-3 text-sm">
            {[
              { to: "/", label: "Accueil" },
              { to: "/services", label: "Nos services" },
              { to: "/realisations", label: "Réalisations" },
              { to: "/contact", label: "Contact" },
            ].map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z]/g, "-")}`}
                  className="text-slate-300 transition-colors hover:text-brand-yellow"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="text-xs font-mono uppercase tracking-[0.28em] text-brand-yellow">Contact direct</h3>
          <ul className="mt-5 space-y-4 text-sm">
            <li>
              <a href={CONTACT.phoneHref} data-testid="footer-phone" className="flex items-center gap-3 text-slate-200 hover:text-brand-yellow transition-colors">
                <Phone className="h-4 w-4 text-brand-red" /> {CONTACT.phone}
              </a>
            </li>
            <li>
              <a href={`mailto:${CONTACT.email}`} data-testid="footer-email" className="flex items-center gap-3 text-slate-200 hover:text-brand-yellow transition-colors">
                <Mail className="h-4 w-4 text-brand-red" /> {CONTACT.email}
              </a>
            </li>
            <li className="flex items-start gap-3 text-slate-400">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-brand-red" />
              <span>
                {CONTACT.addressLine1}
                <br />
                {CONTACT.addressLine2}
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <p className="text-xs leading-relaxed text-slate-400/80">
          Électricien à Argentan et dans l'Orne (61) : électricité générale Argentan, dépannage électricien Argentan,
          dépannage électricité 61, domotique Argentan, borne de recharge Argentan, VMC Argentan, portail électrique
          Argentan, pompes à chaleur et volets roulants — SARL EG 6.1, Urou et Crennes / Gouffern-en-Auge.
        </p>
      </div>
    </div>

    <div className="overflow-hidden border-t border-white/5 py-6" aria-hidden="true">
      <p
        className="whitespace-nowrap text-center font-display text-[16vw] md:text-[10vw] font-black leading-none opacity-40 select-none"
        style={{ WebkitTextStroke: "1px rgba(255,255,255,0.25)", color: "transparent" }}
      >
        EG 6.1
      </p>
    </div>

    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-slate-500">
        <span>© {new Date().getFullYear()} SARL EG 6.1 — SIRET 853 682 482 00015 — Urou et Crennes, Orne (61)</span>
        <span className="flex flex-wrap items-center gap-x-5 gap-y-2">
          <span className="font-mono uppercase tracking-[0.2em]">Électricité Générale — Argentan & alentours</span>
          <Link
            to="/mentions-legales"
            data-testid="footer-link-mentions-legales"
            className="underline underline-offset-4 transition-colors hover:text-brand-yellow"
          >
            Mentions légales
          </Link>
        </span>
      </div>
    </div>
  </footer>
);

export default Footer;
